import { createFileRoute } from '@tanstack/react-router';

import { CuentaSeguridadPage } from '@/pages/cuenta-seguridad';

export const Route = createFileRoute('/_private/cuenta/seguridad')({
  component: CuentaSeguridadPage,
});
